/**
 * Whether the Board's day plan has answered yet (23/10/2026, client QA: "the
 * containers looks empty at the first load, but there's no load so it
 * confuses us"). Today's list, List group, Progress, State and the Total line
 * come from the day preview, which can take up to a minute on a busy tracker;
 * until it answers they show placeholders, never "—" or "nothing planned".
 * For Media Devoted | Created By Ciro Autiero
 */
import { createContext, useContext } from 'react';

export type BoardPreviewState = 'loading' | 'failed' | 'ready';

/** Loading or failed only while there is no plan to show — a refetch keeps the last answer on screen. */
export const previewStateOf = (hasPreview: boolean, loading: boolean, failed: boolean): BoardPreviewState =>
  hasPreview ? 'ready' : loading ? 'loading' : failed ? 'failed' : 'ready';

export const BoardPreviewContext = createContext<BoardPreviewState>('ready');

export const useBoardPreviewState = (): BoardPreviewState => useContext(BoardPreviewContext);
